import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AgentNavbar from "../../../component/AgentNavbar";
import axios from "axios";
import { baseurl } from "../../../component/Baseurl";

function FlightFareRules() {
  const { token } = useParams();
  const [fareRuleResponse, setFareRuleResponse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) return;

    const fetchFareRule = async () => {
      try {
        const response = await axios.post(`${baseurl}fetchFareRule`, {
          ResultToken: token,
        });

        console.log("Fare Rule API Response:", response.data);

        setFareRuleResponse(response.data?.FareRuleResponse?.FareRule || {});
      } catch (err) {
        setError("Failed to fetch fare rule details.");
      } finally {
        setLoading(false);
      }
    };

    fetchFareRule();
  }, [token]);

  useEffect(() => {
    console.log("Updated fareRuleResponse:", fareRuleResponse);
  }, [fareRuleResponse]);

  return (
    <>
       
      <div className="container bg-light p-4 mt-3 rounded shadow">
        {loading && <p>Loading...</p>}
        {error && <p className="text-danger">{error}</p>}

        {fareRuleResponse && (
          <>
            <h4 className="text-start">Cancellation Info</h4>


<div className="text-start text-dark">
<div><strong>Cancellation Charges</strong> : From  
[{fareRuleResponse?.FareRuleDetail?.[0]?.CancellationCharge?.DEFAULT?.start_time || "N/A"}]
&nbsp;
To 
[{fareRuleResponse?.FareRuleDetail?.[0]?.CancellationCharge?.DEFAULT?.end_time || "N/A"}]

[₹{fareRuleResponse?.FareRuleDetail?.[0]?.CancellationCharge?.DEFAULT?.amount || "N/A"}]

With Tax Amount 
[₹{fareRuleResponse?.FareRuleDetail?.[0]?.CancellationCharge?.DEFAULT?.tax || "N/A"}]

</div>

<div><strong>Policy Info : </strong>
{/* [{fareRuleResponse?.FareRuleDetail?.[0]?.CancellationCharge?.DEFAULT?.policyInfo || "N/A"}] */}
[{fareRuleResponse?.FareRuleDetail?.[0]?.DateChange?.DEFAULT?.policyInfo || "N/A"}]
</div>

</div>



            {/* <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Amount</th>
                  <th>Policy Info</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Date Change</td>
                  <td>₹{fareRuleResponse?.FareRuleDetail?.[0]?.DateChange?.DEFAULT?.amount || "N/A"}</td>
                  <td>{fareRuleResponse?.FareRuleDetail?.[0]?.DateChange?.DEFAULT?.policyInfo || "N/A"}</td>
                </tr>
                <tr>
                  <td>Cancellation</td>
                  <td>₹{fareRuleResponse?.FareRuleDetail?.[0]?.CancellationCharge?.DEFAULT?.amount || "N/A"}</td>
                  <td>{fareRuleResponse?.FareRuleDetail?.[0]?.CancellationCharge?.DEFAULT?.policyInfo || "N/A"}</td>
                </tr>
              </tbody>
            </table> */}

            {/* <h4 className="mt-4">Raw API Response</h4>
            <pre className="bg-dark text-white p-3 rounded" style={{ maxHeight: "400px", overflowY: "auto" }}>
              {JSON.stringify(fareRuleResponse, null, 2)}
            </pre> */}
          </>
        )}
      </div>
    </>
  );
}

export default FlightFareRules;
